var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTopUpBalanceIconSmall = function SvgTopUpBalanceIconSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9991 5.33472C30.9933 5.3385 23.275 11.7737 21.6518 20.6321C29.4036 16.3901 39.1265 19.2354 43.3684 26.9872C45.9873 31.7729 45.9873 37.563 43.3684 42.3487C53.5052 40.4918 60.2174 30.769 58.3605 20.6322C56.7368 11.7683 49.0105 5.3313 39.9991 5.33472Z",
    fill: "#D5D5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6682 58.6667C26.032 58.6667 32.0015 52.6971 32.0015 45.3333C32.0015 37.9695 26.032 32 18.6682 32C11.3044 32 5.33484 37.9695 5.33484 45.3333C5.33484 52.6971 11.3044 58.6667 18.6682 58.6667Z",
    fill: "#6563FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3307 18.6653C21.1083 18.6661 14.2251 24.8989 13.4107 33.0808C20.1728 30.1755 28.0099 33.3021 30.9152 40.0642C32.3582 43.4228 32.3582 47.2267 30.9152 50.5853C39.708 49.711 46.1272 41.8743 45.2529 33.0815C44.4392 24.8982 37.5543 18.6645 29.3307 18.6653Z",
    fill: "#A1A1ED"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopUpBalanceIconSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/topUpBalanceIconSmall.f6f0c989.svg";
export { ForwardRef as ReactComponent };